import { Component, OnInit } from '@angular/core';
import { SttTableComponent } from '../../../../shared/components/stt-table/stt-table.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Router } from '@angular/router';
import { ConsumptionTicketModel } from '../../../../shared/entities/consumption-ticket.model';
import { finalize } from 'rxjs/operators';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { ValidationMessageService } from '../../../../shared/services/base/validation-message-handle';
import { ConsumptionTicketService } from '../../../../shared/services/app/consumption-ticket.service';

@Component({
  selector: 'app-consumption-ticket-action-table',
  templateUrl: './consumption-ticket-action-table.component.html',
  styleUrls: ['./consumption-ticket-action-table.component.scss']
})
export class ConsumptionTicketActionTableComponent implements OnInit {

    public data: ConsumptionTicketModel;
    public table: SttTableComponent;
    public ref: DynamicDialogRef;
    public loading = true;

    constructor(
        public dialogService: DialogService,
        public router: Router,
        public confirmationService: ConfirmationService,
        public primengConfig: PrimeNGConfig,
        public itemService: ConsumptionTicketService,
        public messageService: MessageService,
        private validationMessageService: ValidationMessageService,
    ) {

    }

    ngOnInit(): void {
    }

    setParams(entity: ConsumptionTicketModel): void {
        this.data = entity;
    }

    setTableReference(table: SttTableComponent): void
    {
        this.table = table;
    }

    showDialog(){
        this.router.navigate(
            ['stock-management/consumption-ticket/add-edit'],
            { queryParams: { uid: this.data.uid } }
        );
    }

    confirm() {
        this.confirmationService.confirm({
            header: 'Confirmare stergere Bon de consum productie',
            message: 'Sunteti sigur ca doriti sa stergeti acest bon de consum productie?',
            key: 'deleteConsumptionTicket',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Da',
            rejectLabel: 'Nu',
            acceptButtonStyleClass: 'p-button-md p-button-success',
            rejectButtonStyleClass: 'p-button-md p-button-danger',
            accept: () => {
                this.deleteItem(this.data.uid);
            },
            reject: () => {
                this.confirmationService.close();
                this.table.refresh();
            }
        });
    }

    deleteItem(uid: string){
        this.itemService.delete(uid)
            .pipe(finalize(() => {this.loading = false;this.table.refresh();}))
            .subscribe((response: any) => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Bonul de consum productie a fost sters cu success!'
                });
            });
    }

}
